import React, { useEffect, useRef, useState } from "react";
import { Rnd } from "react-rnd";
import AdrgData from "../../AdrgData";
import DynamicRuler from "./DynamicRuler";
import { Table } from "react-bootstrap";
import "../../../../../FormReport/CommonDesign/print.css";
import ADRGPdfDataDetails from "../../ADRGPdfDataDetails";

const EditorWritingPage = ({
  size,
  margin,
  tables,
  imageSrc,
  formType,
  shapeSize,
  showFooter,
  showHeader,
  orientation,
  renderShape,
  setShapeSize,
  setActiveTab,
  isFullScreen,
  componentRef,
  imageToInsert,
  shapeToInsert,
  emojiToInsert,
  tableProperties,
  setSelectedCell,
  setSelectedTableIndex,
  getCellAlignmentStyles,
  handleLinePositionChange,
}) => {
  const editorRef = useRef(null);
  const editorStyle = { width: "100%" };
  const marginStyle = {
    paddingTop: margin.top,
    paddingBottom: margin.bottom,
    paddingLeft: margin.left,
    paddingRight: margin.right,
  };

  const pageStyle = {
    width: orientation === "portrait" ? size.width : size.height,
    height: orientation === "portrait" ? size.height : size.width,
    marginBottom: margin.bottom,
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  };

  const contentStyle = {
    ...marginStyle,
    flexGrow: 1,
  };

  const insertImageAtCaret = (imageSrc) => {
    const img = document.createElement("img");
    img.src = imageSrc;
    img.style.maxWidth = "100%";
    img.style.maxHeight = "100%";

    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      range.insertNode(img);
      range.collapse(false);
    }
  };

  useEffect(() => {
    if (imageToInsert) {
      insertImageAtCaret(imageToInsert);
    }
  }, [imageToInsert]);

  const insertEmojiAtCaret = (emoji) => {
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      const emojiNode = document.createTextNode(emoji);
      range.insertNode(emojiNode);
      range.collapse(false);
    }
  };

  useEffect(() => {
    if (emojiToInsert) {
      insertEmojiAtCaret(emojiToInsert);
    }
  }, [emojiToInsert]);

  return (
    <>
      <DynamicRuler
        orientation={orientation}
        size={size}
        onLinePositionChange={handleLinePositionChange}
      />
      <div
        style={{
          height: isFullScreen ? "calc(100vh - 115px)" : "calc(100vh - 275px)",
          overflow: "auto",
        }}
      >
        <div className="text-editor text-editor-container" ref={editorRef}>
          <div
            contentEditable={true}
            style={{
              border: "1px solid #eee",
              borderRadius: 3,
              outline: "none",
              minHeight: "11in",
              ...editorStyle,
              ...pageStyle,
            }}
            suppressContentEditableWarning={true}
          >
            <div ref={componentRef}>
              {showHeader && (
                <div
                  className="singleFormHeader w-100"
                  style={{ ...contentStyle, borderBottom: "2px dashed #eee" }}
                  contentEditable={true}
                >
                  <div className="d-flex justify-content-between">
                    <p className="m-0 fw-bold">Study 006-24</p>
                    <p className="m-0 fw-bold">
                      Analysis Data Reviewer’s Guide
                    </p>
                  </div>
                </div>
              )}
              <div style={{ ...contentStyle }}>
                <Table>
                  {showHeader && (
                    <thead>
                      <tr className="spacingHeader">
                        <th className="border-0">
                          {!formType === "studyform" && (
                            <div className="t-head">&nbsp;</div>
                          )}
                          <div className="t-head">&nbsp;</div>
                          <div className="t-head">&nbsp;</div>
                          <div className="t-head">&nbsp;</div>
                        </th>
                      </tr>
                    </thead>
                  )}
                  <tbody>
                    <tr>
                      <td className="border-0 p-0">
                        <div className="content">
                          {imageSrc && (
                            <div className="page">
                              <Rnd
                                default={{
                                  x: 50,
                                  y: 50,
                                  width: 200,
                                  height: 200,
                                }}
                                lockAspectRatio={false}
                                bounds="parent"
                              >
                                <img
                                  src={imageSrc}
                                  alt="Selected"
                                  style={{
                                    objectFit: "cover",
                                    width: 100,
                                    height: 100,
                                  }}
                                />
                              </Rnd>
                            </div>
                          )}
                          {shapeToInsert && (
                            <div className="page">
                              <Rnd
                                default={{
                                  x: 100,
                                  y: 100,
                                  width: 100,
                                  height: 100,
                                }}
                                lockAspectRatio={false}
                                bounds="parent"
                                onResize={(
                                  e,
                                  direction,
                                  ref,
                                  delta,
                                  position
                                ) => {
                                  setShapeSize({
                                    width: ref.style.width,
                                    height: ref.style.height,
                                  });
                                }}
                              >
                                <div style={{ fontSize: 50 }}>
                                  {renderShape(
                                    shapeToInsert,
                                    shapeSize.width,
                                    shapeSize.height
                                  )}
                                </div>
                              </Rnd>
                            </div>
                          )}
                          {tables?.length > 0 && (
                            <div className="page">
                              {tables?.map((table, index) => (
                                <div
                                  key={index}
                                  className="table-container"
                                  onClick={() => {
                                    setActiveTab("Home");
                                    setSelectedTableIndex(index);
                                  }}
                                >
                                  <Table
                                    bordered
                                    style={{
                                      width: 100,
                                      tableLayout: "fixed",
                                      borderColor: `${tableProperties.borderColor}`,
                                      borderWidth: `${tableProperties.borderWidth}px`,
                                    }}
                                  >
                                    <tbody>
                                      {Array(table.rows)
                                        .fill(0)
                                        .map((_, rowIndex) => (
                                          <tr
                                            key={rowIndex}
                                            style={{
                                              minHeight: `${tableProperties.minRowHeight}px`,
                                              position:
                                                rowIndex <
                                                tableProperties.pinHeaderRows
                                                  ? "sticky"
                                                  : "static",
                                              top:
                                                rowIndex <
                                                tableProperties.pinHeaderRows
                                                  ? 0
                                                  : "auto",
                                              backgroundColor:
                                                rowIndex <
                                                tableProperties.pinHeaderRows
                                                  ? "#f8f9fa"
                                                  : "inherit",
                                            }}
                                          >
                                            {Array(table.columns)
                                              .fill(0)
                                              .map((_, colIndex) => (
                                                <td
                                                  key={colIndex}
                                                  style={{
                                                    padding: `${tableProperties.cellPadding}px`,
                                                    height: `${tableProperties.minRowHeight}px`,
                                                    width: `${tableProperties.columnWidth}px`,
                                                    borderWidth: `${tableProperties.borderWidth}px`,
                                                    borderColor: `${tableProperties.borderColor}`,
                                                    ...getCellAlignmentStyles(
                                                      tableProperties.cellAlignment
                                                    ),
                                                    backgroundColor:
                                                      table.cells[rowIndex][
                                                        colIndex
                                                      ]?.backgroundColor ||
                                                      "#ffffff",
                                                  }}
                                                  contentEditable
                                                  onClick={() =>
                                                    setSelectedCell({
                                                      rowIndex,
                                                      colIndex,
                                                    })
                                                  }
                                                ></td>
                                              ))}
                                          </tr>
                                        ))}
                                    </tbody>
                                  </Table>
                                </div>
                              ))}
                            </div>
                          )}
                          <div className="page">
                            <AdrgData />
                          </div>
                          <div className="pages">
                            <ADRGPdfDataDetails />
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  {showFooter && (
                    <tfoot>
                      <tr className="spacingHeader">
                        <td className="border-0 p-0">
                          <div className="t-foot">&nbsp;</div>
                          <div className="t-foot">&nbsp;</div>
                          <div className="t-foot">&nbsp;</div>
                        </td>
                      </tr>
                    </tfoot>
                  )}
                </Table>
              </div>
              {showFooter && (
                <div
                  className="footer bg-white text-center"
                  style={{
                    ...contentStyle,
                    borderTop: "1px dashed #eee",
                  }}
                >
                  <div className="hstack justify-content-between">
                    <span contentEditable={true}>Confidencials</span>
                    <span style={{ pointerEvents: "none" }}>Page : 1 of 1</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditorWritingPage;
